import ExternalFileControlTable from '../components/externalFileControlTable/externalFileControlTable.vue'

export default {
  components: {
    ExternalFileControlTable,
  },

  data: () => ({}),

  methods: {},

  created() {},
}
